import React from 'react';
import { BoardPositionsList } from '../components/board/BoardPositionsList';

export default function BoardPositionsPage() {
    return <BoardPositionsList />;
}
